import React, { memo, MouseEvent, useMemo } from 'react';

import { Checkbox } from '@components/common';

import { ITreeCheckboxOption } from '@interfaces/components/tree';

import { SELECT_TREE_ALL_CHECKED } from '@components/common/FlatTree/constants';

import styles from '../TreeSelect.module.scss';

interface ITreeSelectItemsListProps {
	list: (ITreeCheckboxOption | { value: string; isChecked: boolean; isSelected: boolean })[];
	handleChange: (item: { name: string; checked: boolean }) => void;
	isSemiChecked: boolean;
	isSingleSelectMode?: boolean;
}

const TreeSelectItemsList = ({
	list,
	handleChange,
	isSemiChecked,
	isSingleSelectMode,
}: ITreeSelectItemsListProps) => {
	const onClick = (name: string, checked: boolean) => {
		return (e: MouseEvent<HTMLDivElement>) => {
			e.stopPropagation();
			e.preventDefault();
			handleChange({ name, checked });
		};
	};

	const selectedItems = useMemo(() => list.filter((item) => item.isSelected), [list]);

	return (
		<div className={styles.items}>{
			selectedItems
				.map((item, index) => {
					return (
						<div
							key={index}
							className={styles.item}
							onClick={onClick(item.value, item.isChecked)}
						>
							<div className={styles.itemWrapper}>
								{!isSingleSelectMode &&
									<Checkbox
										checked={item.isChecked}
										isIndefinite={item.value === SELECT_TREE_ALL_CHECKED && isSemiChecked}
										name={item.value}
									/>
								}
								{item.value}
							</div>
						</div>
					);
				})
		}</div>
	);
};

export default memo(TreeSelectItemsList);
